import { Controller } from '@hotwired/stimulus';
/*
 * Description
 * -------
 *
 * Displays countdown to a specific date and dispatches a 'finished' event when the countdown is finished.
 * Can be used on any element.
 * Can be used multiple times in the document.
 *
 * Targets
 * -------
 *
 * days    - (required) - days element
 * hours   - (required) - hours element
 * minutes - (required) - minutes element
 * seconds - (required) - seconds element
 *
 * Values
 * -------
 *
 * date - (required) - date to countdown to
 *
 * Usage
 * -------
 *
 * <div data-controller="countdown" data-countdown-date-value="Oct 17, 2024 10:37:25">
 *   <div data-countdown-target="days">0</div>
 *   <div data-countdown-target="hours">0</div>
 *   <div data-countdown-target="minutes">0</div>
 *   <div data-countdown-target="seconds">0</div>
 * </div>
 */
export default class default_1 extends Controller {
    static targets = ['badge', 'inner', 'days', 'hours', 'minutes', 'seconds'];
    static values = {
        date: { type: String },
    };
    connect() {
        this.set();
        this.interval = setInterval(() => {
            this.set();
        }, 1000);
    }
    disconnect() {
        clearInterval(this.interval);
    }
    set() {
        const countDownDate = new Date(this.dateValue).getTime();
        const now = new Date().getTime();
        const distance = countDownDate - now;
        const days = Math.floor(distance / (1000 * 60 * 60 * 24));
        const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((distance % (1000 * 60)) / 1000);
        if (days > 0) {
            this.daysTarget.innerHTML = days.toString();
        }
        else {
            this.daysTarget.innerHTML = '0';
        }
        if (hours > 0) {
            this.hoursTarget.innerHTML = hours.toString();
        }
        else {
            this.hoursTarget.innerHTML = '0';
        }
        if (minutes > 0) {
            this.minutesTarget.innerHTML = minutes.toString();
        }
        else {
            this.minutesTarget.innerHTML = '0';
        }
        if (seconds > 0) {
            this.secondsTarget.innerHTML = seconds.toString();
        }
        else {
            this.secondsTarget.innerHTML = '0';
        }
        if (distance <= 0) {
            if (this.hasBadgeTarget)
                this.badgeTarget.classList.remove('hidden');
            this.innerTarget.remove();
            this.dispatch('finished');
        }
    }
}
